import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import UPAdminDropdownButton from 'client/components/UPAdminDropdownButton/UPAdminDropdownButton';

import './SrUtilityProfitActivationsDataTableHeader.less';
import { isHomebuyerPartner } from 'common/utility/helpers';

export const MOVE_IN_DATE_FILTER_PAST = 'past';
export const MOVE_IN_DATE_FILTER_UPCOMING = 'upcoming';
export const MOVE_IN_DATE_FILTER_ALL = 'all';

const MOVE_IN_DATE_FILTERS = [
  { label: 'Upcoming', value: MOVE_IN_DATE_FILTER_UPCOMING },
  { label: 'Past', value: MOVE_IN_DATE_FILTER_PAST },
  { label: 'All', value: MOVE_IN_DATE_FILTER_ALL },
];

const SrUtilityProfitActivationsDataTableHeader = ({
  searchInput,
  onSearchInputChange,
  moveInDateFilter,
  setMoveInDateFilter,
  utilityPartner,
}) => {
  const moveInFilterTitle = MOVE_IN_DATE_FILTERS.find(({ value }) => value === moveInDateFilter)
    .label;

  const searchFieldPlaceholder = isHomebuyerPartner(utilityPartner)
    ? 'Search Address or Client (Name or Phone)'
    : 'Search Address or Tenant (Name or Phone)';

  return (
    <SrBox styleName="SrUtilityProfitActivationsDataTableHeader">
      <SrBox display="flex" alignItems="baseline">
        <SrText font="greycliff" weight="700" fontSize="28px">
          Utility Activations
        </SrText>

        <SrBox marginLeft="24px" marginBottom="-18px">
          <UPAdminDropdownButton
            title={
              <SrText font="greycliff" weight="500" fontSize="16px">
                Filter:
                <SrText font="greycliff" weight="700" fontSize="16px">
                  {` ${moveInFilterTitle} `}
                </SrText>
              </SrText>
            }
            options={MOVE_IN_DATE_FILTERS.map(({ label, value }) => ({
              label,
              value,
              selected: value === moveInDateFilter,
            }))}
            onClickOption={setMoveInDateFilter}
            boxShadow="none"
            className="dataTableFilter"
          />
        </SrBox>
      </SrBox>

      <SrBox minWidth="280px" maxWidth="300px" height="28px" marginLeft="auto">
        <input
          value={searchInput}
          type="text"
          onChange={onSearchInputChange}
          placeholder={searchFieldPlaceholder}
          styleName="searchInput"
        />
      </SrBox>
    </SrBox>
  );
};

SrUtilityProfitActivationsDataTableHeader.displayName = 'SrUtilityProfitActivationsDataTableHeader';

SrUtilityProfitActivationsDataTableHeader.propTypes = {
  onSearchInputChange: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  utilityPartner: PropTypes.object,
};

export default SrUtilityProfitActivationsDataTableHeader;
